export default __webpack_public_path__ + "static/media/uptime.e133d4f9.svg";